/*
 * MDB shim for MDBCardBody
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/InformationChangeModal.jsx
 * - src/Components/Custom/InlineTable.jsx
 * - src/Components/Pipeline/MonthGlance.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Patient/PatientViewComponents/HomeAssessmentModal.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/notesTab.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/PresidentsClub/presidentsClubView.jsx
 */

import MUICardContent from "@mui/material/CardContent";

export default function MDBCardBody({ children, className, style, ...rest }) {
    return (
        <MUICardContent className={className} style={style} {...rest}>
            {children}
        </MUICardContent>
    );
}
